import { SellerApi } from 'api/SellerApi';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { SellerDealsFilterTag } from 'components/seller/dealshome/SellerDealsFilterTag';
import { LoginResponseUserModel } from 'models/identity/LoginResponseUserModel';
import { DealTagModel } from 'models/seller/deals/DealsModels';
import { FilterStateModel } from 'models/seller/project/ProjectModels';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { Badge, Card, FormControl } from 'react-bootstrap';
import { CaretDownFill, TagsFill } from 'react-bootstrap-icons';

type PropTypes = {
  currentUser: LoginResponseUserModel;
  t: any;
  handleTagFilter: (tagIds: number[]) => void;
  filterState: FilterStateModel;
};

export const SellerDealsTagSearch = ({
  currentUser,
  t,
  filterState,
  handleTagFilter,
}: PropTypes) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [lastTags, setLastTags] = useState<DealTagModel[]>([]);
  const [tagIds, setTagIds] = useState<number[]>([]);

  const handleClick = async (): Promise<void> => {
    setIsEditing(!isEditing);

    const response = await SellerApi.getLastTags(currentUser.companyId);

    setLastTags(response);
  };

  const handleSearchTag = async (event: ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value;

    const response = await SellerApi.getLastTags(currentUser.companyId, query);

    setLastTags(response);
  };

  useEffect(() => {
    const getFirstTags = async (): Promise<void> => {
      const response = await SellerApi.getLastTags(currentUser.companyId);

      setLastTags(response);
    };

    getFirstTags();
  }, [currentUser.companyId]);

  const handleSearchDebounced = AwesomeDebouncePromise(handleSearchTag, 400);

  const handleUsedClick = (tag: DealTagModel) => {
    let clone = [...tagIds];

    const index = clone.indexOf(tag.id);

    if (clone.includes(tag.id) && index > -1) {
      clone.splice(index, 1);
    } else clone.push(tag.id);

    setTagIds(clone);
    handleTagFilter(clone);
    setIsEditing(false);
  };

  /* Detect click outside the tags-search div */
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (
        ref.current &&
        !ref.current.contains(event.target as Node) &&
        !(event.target as Element).classList?.contains('btn-tags-filter')
      ) {
        setIsEditing(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return (
    <>
      <div>
        <div
          className='btn btn-eleczap ms-2 btn-tags-filter'
          onClick={handleClick}
        >
          <TagsFill
            size={15}
            style={{ cursor: 'pointer' }}
            className='icon-ez-white dropdown-toggle'
          />{' '}
          {t('deals.lbl_Tags')} <CaretDownFill />
        </div>
        {isEditing ? (
          <div ref={ref} className='recent-tags-container'>
            <Card className='recent-tags'>
              <FormControl
                className='tags-input mb-1 mt-1 px-3'
                onChange={handleSearchDebounced}
                autoFocus
                // onBlur={handleBlur}
              />

              <hr className='mx-1 my-0 mt-1' />

              <div className='text-center icon-ez-gray recent-tags-header-text mt-1'>
                {t('common.hd_RecentlyUsed')}
              </div>

              <Card.Body className='justify-content-start text-start'>
                {lastTags !== null &&
                  lastTags.map((tag) => (
                    <>
                      <Badge
                        onClick={() => handleUsedClick(tag)}
                        pill
                        className={
                          filterState.tagIds.includes(tag.id)
                            ? 'deals-pill-inverse m-1 cursor-pointer'
                            : 'deals-pill m-1 cursor-pointer'
                        }
                      >
                        {tag.name}
                      </Badge>
                      <br />
                    </>
                  ))}
              </Card.Body>
            </Card>
          </div>
        ) : (
          <div />
        )}
      </div>
      {lastTags !== null &&
        lastTags.map(
          (tag) =>
            filterState.tagIds.includes(tag.id) && (
              <SellerDealsFilterTag
                handleUsedClick={handleUsedClick}
                tag={tag}
              />
            )
        )}
    </>
  );
};
